import {
  OnInit,
  Component,
  Output,
  EventEmitter,
  HostListener,
  Inject,
} from "@angular/core";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
// import { AngularFireMessaging } from "@angular/fire/messaging";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone:false,
})
export class AppComponent implements OnInit {
  loading = true;
  lastPing?: Date = null;
  showAlert: boolean = false;
  message: any;

  constructor(
    public timeoutService: TimeoutService,
    // private angularFireMessaging: AngularFireMessaging,
    // private messagingService: MessagingService
  ) {}

  ngOnInit() {
    this.loading = false;
    // this.messagingService.requestPermission();
    // this.messagingService.receiveMessage();

    // this.message = this.messagingService.currentMessage;
  }

  ngAfterViewInit() {
    const head = document.getElementsByTagName("body")[0];
    const script = document.createElement("script");
    script.src = "./assets/js/scripts.bundle.js";
    script.type = "text/javascript";
    var oldJs = document.getElementsByTagName("script");
   

    
    
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      if (element.src.indexOf("scripts.bundle.js") != -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }
    head.appendChild(script);
  }
}

import { Directive, Input } from "@angular/core";
import {
  MatDialog as MatDialog,
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ModuleService } from "./services/module.service";
import { NgBlockUI, BlockUI } from "ng-block-ui";
import { AuthService } from "./services/auth.service";
import { TimeoutService } from "./services/timeout.service";
// import { MessagingService } from "./services/messaging.service";

@Directive({
  selector: "[confirmation]",
})
export class ConfirmDirective {
  constructor(public dialog: MatDialog) {}

  @Output("confirmation") click: any = new EventEmitter();
  @Input("message") message: string;
  @Input("title") title: string;
  @Input("yesBtn") yesBtn: string;
  @Input("noBtn") noBtn: string;

  @HostListener("click", ["$event"]) clicked(e) {
    const data = {
      options: {
        title: this.title || "Confirmation",
        msg: this.message || "Are you sure?",
        yesBtn: this.yesBtn || "Confirm",
        noBtn: this.noBtn || "Cancel",
      },
      confirm: this.click,
    };
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: "500px",
      data: data,
    });
  }
}

@Component({
  selector: "modal-content",
  template: `
    <h3 mat-dialog-title>{{ options.title }}</h3>
    <div mat-dialog-content>
      <p>{{ options.msg }}</p>
    </div>
    <div class=" ">
      <button
        type="button"
        class="btn btn-label btn-label-brand btn-sm btn-bold "
        (click)="declined()"
      >
        {{ options.noBtn }}
      </button>
      <button
        class="btn btn-brand btn-sm btn-bold btn-wide float-right "
        type="button"
        (click)="confirmed()"
        color="primary"
      >
        {{ options.yesBtn }}
      </button>
    </div>
  `,
})
export class ConfirmModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  options: any;

  ngOnInit() {
    this.options = this.data.options;
  }

  confirmed() {
    this.data.confirm.emit();
    this.dialogRef.close();
  }

  declined() {
    this.dialogRef.close();
  }
}
